import { Injector } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SpinnerService } from '../../../core/services/spinner.service';
import { ToasterService } from '../../../core/services/toaster.service';

export class BaseClassComponent {
  public formBuilder: FormBuilder;
  public _router: Router;
  public _spinnerService: SpinnerService;
  public _toasterService: ToasterService;
  public _activatedRoute: ActivatedRoute;
  public _translateService: TranslateService;

  constructor(injector: Injector) {
    this.formBuilder = injector.get(FormBuilder);
    this._router = injector.get(Router);
    this._activatedRoute = injector.get(ActivatedRoute);
    this._spinnerService = injector.get(SpinnerService);
    this._toasterService = injector.get(ToasterService);
    this._translateService = injector.get(TranslateService);
  }
}
